import React, { useState } from "react"
import { Link } from "gatsby"
import Breadcrumb from "§/src/components/atoms/breadcrumb/breadcrumb"

/**
 * Internal dependencies.
 */
import MainNav from './navs/main-nav';
import TopNav from './navs/top-nav';
import './_header.scss';

// Search
import Search from './search'

// Language
import { useTranslation } from 'react-i18next';

const productIndex = 'Products_' + process.env.GATSBY_SITE_LANG + '_dev'
const newsIndex = 'NewsEvents_' + process.env.GATSBY_SITE_LANG + '_dev'
const applicationsIndex = 'Applications_' + process.env.GATSBY_SITE_LANG + '_dev'
const caseHistoriesIndex = 'Case_Histories_' + process.env.GATSBY_SITE_LANG + '_dev'


// import DevGrid from './../_dev/grid';
// <DevGrid></DevGrid>

const Header = ( { data, className, breadcrumbs, lang, langReplace } ) => {

	const { t } = useTranslation();

	const [showSearch, setShowSearch] = useState(false)
	const [scrollTopPos, setScrollTopPos] = useState(0)

	const searchIndices = [
		{ name: productIndex, title: t('Prodotti'), type: 'products' },
		{ name: newsIndex, title: t('News & eventi'), type: 'news' },
		{ name: applicationsIndex, title: ('Applications'), type: 'applications' },
		{ name: caseHistoriesIndex, title: ('Case History'), type: 'casehistories' },
	]


	const { getHeader: { siteTitle, siteTagLine } } = data.wp;
	const headerMenu = data.headerMenu;
	const headerCatMenu = data.headerCatMenu;
	const langMenu = data.langMenu;
	const topMenu = data.topMenu;
	const socialMenu = data.socialMenu;
	const general = data.wp.generalSettings;
	const categories = data.categories;

	const onSearchVisible = () => {
    setShowSearch(true)
    if (!document.body.classList.contains("algolia-open")) {
      // save current scroll position
      setScrollTopPos(
        document.documentElement.scrollTop || document.body.scrollTop
      )
      // scroll up
      document.documentElement.scrollTop = document.body.scrollTop = 0
      // document.getElementById("searchbar").classList.add("active")
      // document.getElementById("algoliaInput").focus()
      document.body.classList.add("algolia-open")
      document.querySelector("body").style.overflowY = "hidden"
    }
  }

  const onSearchHidden = () => {
    setShowSearch(false)
    if (document.body.classList.contains("algolia-open")) {
      // scroll back to saved position
      document.documentElement.scrollTop = scrollTopPos
      document.body.scrollTop = scrollTopPos
      // document.getElementById("searchbar").classList.remove("active")
      // document.body.querySelector("algoliaInput").blur()
      document.body.classList.remove("algolia-open")
      document.querySelector("body").style.overflowY = "auto"
    }
  }

	return (
		<React.Fragment>
			<TopNav
				lang={lang}
				langReplace={langReplace}
				langMenu={langMenu}
				topMenu={topMenu}
				socialMenu={socialMenu}
				general={general}
			/>
			<header id="main-header" className={className}>
				<MainNav
					lang={lang}
					langReplace={langReplace}
					wpMenu={headerMenu}
					wpCatMenu={headerCatMenu}
					categories={categories}
					title={siteTitle}
					tagline={siteTagLine}
					rawData={data}
					onSearchClick={onSearchVisible}
					onCloseClick={onSearchHidden}
				/>
				<div id="dropdown-bg">
					<div className="first-level"></div>
				</div>
				<div id="dropdown-chevron"></div>
			</header>
			{showSearch && <Search indices={searchIndices} />}
		</React.Fragment>
	);
};

export { Header };
